import React, { ElementType, HTMLAttributes, ReactNode } from 'react';

// components
import Typography from '@/components/elements/Typography';
import clsx from 'clsx';

type Classes = {
  root: string;
  iconContainer: string;
  icon: string;
  text: string;
};

export type ListItemProps = {
  icon?: ElementType;
  children?: ReactNode;
  button?: boolean;
  fullWidth?: boolean;
  selected?: boolean;
  classes?: Partial<Classes>;
} & HTMLAttributes<HTMLElement>;

/**
 * @component ListItem
 */
const ListItem = React.forwardRef<HTMLLIElement, ListItemProps>(
  (props, ref) => {
    const {
      icon,
      fullWidth,
      classes,
      className,
      button,
      selected,
      children,
      ...rest
    } = props;

    // To fixed linter error
    // TODO: find out better solution to the this hack
    const Icon = icon as ElementType;

    // #region Classes
    const rootClasses = clsx(
      `list-none h-[42px] focus:outline-none flex items-center transition rounded-lg px-3.5`,
      {
        'hover:bg-gray-100 cursor-pointer': button,
        'w-full': fullWidth,
        'bg-gray-100': selected,
      },
      className,
      classes?.root,
    );
    const iconContainerClasses = clsx(`justify-center`, classes?.iconContainer);
    const iconClasses = clsx(
      `w-6 h-6 m-auto`,
      { 'text-green-700': selected, 'text-gray-400': !selected },
      classes?.icon,
    );
    const textClasses = clsx(
      `flex-1`,
      { 'text-green-700 !font-semibold': selected, 'text-gray-500': !selected },
      classes?.text,
    );
    // #endregion

    return (
      <li ref={ref} className={rootClasses} {...rest}>
        <div className={iconContainerClasses}>
          {icon && <Icon className={iconClasses} />}
        </div>
        <Typography variant="body" className={textClasses}>
          {children}
        </Typography>
      </li>
    );
  },
);

ListItem.displayName = `ListItem`;

export default ListItem;
